/* eslint-disable no-unreachable */
import ufeApi from 'services/api/ufeApi';

function initializeKlarnaCheckout(payload) {
    const url = '/api/checkout/klarna/createSession';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default initializeKlarnaCheckout;
